<template>
<div class="infopane" style="width:100%">
<v-expansion-panel focusable dark class="mt-1">
<v-expansion-panel-content class="box " v-for="(item,key) in data" :key=key> 
                            <div slot="header" >{{item.heading}}</div>
                            <v-card class="box maxHeight">
                                <v-card-text v-html="item.text">
      
      </v-card-text>
        </v-card>
        </v-expansion-panel-content>
</v-expansion-panel>
</div>
</template>

<script>
export default {
  name: 'InfoPane',
  props: {
      data: Array
  }
}
</script>

<style scoped>
  .maxHeight {
    max-height:200px;
    overflow-y: scroll;
    margin-bottom:20px;
  }
</style>